import RootLayout from 'layouts/RootLayout';
import React, { ReactElement } from 'react';
import type { Route } from 'next';
import classNames from 'classnames/bind';
import dynamic from 'next/dynamic';
import Breadcrumbs from 'components/Breadcrumbs';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
import styles from 'pages/resources/bill-of-lading/BillOfLading.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/BillOfLading/components/SectionHeader'));
const SectionPitch = dynamic(() => import('sections/Resources/BillOfLading/components/SectionPitch'));
const SectionAbout = dynamic(() => import('sections/Resources/BillOfLading/components/SectionAbout'));
const SectionParties = dynamic(() => import('sections/Resources/BillOfLading/components/SectionParties'));
const SectionTypes = dynamic(() => import('sections/Resources/BillOfLading/components/SectionTypes'));
const SectionLegal = dynamic(() => import('sections/Resources/BillOfLading/components/SectionLegal'));
const SectionDifferences = dynamic(() => import('sections/Resources/BillOfLading/components/SectionDifferences'));
const SectionChallenges = dynamic(() => import('sections/Resources/BillOfLading/components/SectionChallenges'));
// const SectionSolutions = dynamic(() => import('sections/Resources/BillOfLading/components/SectionSolutions'));
const SectionSteps = dynamic(() => import('sections/Resources/BillOfLading/components/SectionSteps'));
const SectionTakeaways = dynamic(() => import('sections/Resources/BillOfLading/components/SectionTakeaways'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionSignUp = dynamic(() => import('sections/Resources/BillOfLading/components/SectionSignUp'));
const SectionFaq = dynamic(() => import('sections/Resources/BillOfLading/components/SectionFaq'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionCallToAction = dynamic(() => import('sections/Resources/BillOfLading/components/SectionCallToAction'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/BillOfLading/components/SectionRelatedPosts'));

interface BillOfLadingProps {
  articles: TopArticlesCardType[];
}

export default function BillOfLading({ articles }: BillOfLadingProps) {
  return (
    <div className={cn('bill-of-lading')}>
      <div className={cn('container')}>
        <Breadcrumbs mTop={64} mode="light" links={[{ title: 'Bill of Lading', href: '' as Route }]} />
      </div>
      <SectionHeader/>
      <SectionPitch/>
      <SectionAbout/>
      <SectionParties/>
      <SectionTypes/>
      <SectionLegal/>
      <SectionDifferences/>
      <SectionChallenges/>
      {/* <SectionSolutions/> */}
      <SectionSteps/>
      <SectionTakeaways/>
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionSignUp/> */}
      <SectionFaq/>
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionCallToAction/> */}
      <SectionRelatedPosts articles={articles}/>
    </div>
  );
}

export const getStaticProps = async () => {
  const meta = {
    title: 'Bill of Lading: A Complete Shipper Guide (BoL) | DF Alliance  ',
    description:
      'Access essential resources like Bill of Lading, Blacklist, and more with DF Alliance to enhance your knowledge and optimize your global freight operations.',
    path: '/resources/bill-of-lading',
  };
  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return { props: { articles, ...meta } };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return { props: { articles: [], ...meta } };
};

BillOfLading.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
